import * as React from "react";
export interface IMenuItem {
    title: string;
    action: Function;
}
export interface IMenu {
    title: string;
    items: IMenuItem[];
}
export class MenuItem implements IMenuItem {
    title: string;
    action: Function;
    constructor(title: string, action: Function) {
        this.title = title;
        this.action = action;
    }
}
export interface IMainMenuProps {
    menu: IMenu;
}
export class MainMenuComponent extends React.Component<IMainMenuProps, any> {
    render() {
        const itemsList = this.props.menu.items.map((item, index) => <li key={index}><button onClick={() => item.action()}>{item.title}</button></li>);
        return (
            <div className="container">
                <div className="col-md-6 col-md-offset-3 p-t-90">
                    <div id="mainMenu">
                        <div className="content-box">
                            <div className="logo"/>
                            <h1>{this.props.menu.title}</h1>
                            <ul>{itemsList}</ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
